import { filter, mergeMap, of } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import type { Epic } from '../../../index.js'
import { orderSlice } from '../../../Slice/Order/OrderSlice.js'

export const UpdateSampleEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.updateContentRequest.match),
    mergeMap((action) =>
      OrderRepository.updatePoolContent(action.payload.orderId, action.payload.samplePoolId, action.payload.data).pipe(
        mergeMap((response) => {
          return of(order.updateContentSuccess({ orderId: action.payload.orderId, poolId: action.payload.samplePoolId, content: response }))
        }),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.updateContentFailure({ error }))
          })
        )
      )
    )
  )
